import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import _ from 'lodash'
import store from '../store'
import router from '../router'

require('promise.prototype.finally').shim()

const toast = function (message, type) {
  if (_.isEmpty(type)) {
    type = 'warn'
  }
  try {
    Vue.$vux.toast.show({
      type: type,
      text: message,
      time: 1000
    })
  } catch (e) {
    console.log(e)
  }
}

const http = axios.create({
  baseURL: window.API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

http.interceptors.request.use(config => {
  let token = store.getters.token
  if (!_.isEmpty(token)) {
    config.headers['Authorization'] = token
  }
  return config
})

http.interceptors.response.use(response => {
  return response
}, error => {
  if (_.isUndefined(error.response)) {
    toast('网络异常,请稍后试')
    return Promise.reject(new Error('网络异常,请稍后试'))
  }
  let status = error.response.status
  if (status === 400) {
    let title = _.get(error, 'response.data.message', '请求失败,请稍后再试')
    if (!_.has(error, 'response.data.errors')) {
      toast(title)
    }
    return Promise.reject(error)
  }
  if (status === 403) {
    let errorMessage = _.get(error, 'response.data.message', '缴费已暂停,请稍后再试')
    if (!_.has(error, 'response.data.errors')) {
      toast(errorMessage)
    }
    router.go(-1)
    return Promise.reject(new Error(errorMessage))
  }
  if (status === 401) {
    let errorMessage = '登陆超时,请重新登陆'
    let isLogin = router.currentRoute.path === '/login'
    if (isLogin) {
      errorMessage = '用户名/密码不正确'
    }
    toast(errorMessage)
    store.dispatch('clean')
    if (!isLogin) {
      router.replace({path: '/login'})
    }
    return Promise.reject(new Error(errorMessage))
  }
  if (status === 404) {
    toast('未知操作/页面')
    return Promise.reject(new Error('未知操作/页面'))
  }
  if (status === 500) {
    toast('服务器异常,请稍后再试')
    return Promise.reject(new Error('服务器异常,请稍后再试'))
  }
  if (status === 502) {
    toast('维护中,请稍后再试')
    return Promise.reject(new Error('维护中,请稍后再试'))
  }
  return Promise.resolve(error.response)
})

Vue.use(VueAxios, http)



// WEBPACK FOOTER //
// ./src/components/http.js